import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { deleteBanner, getBanner, updateBanner } from '../../../api/banner.api';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IGetBanner } from '../../../models/banner.model';
import Editor from '../../../components/homepage/main-banner/Editor';

interface IMatch {
  bannerCode: string;
}

const MainBannerEdit = () => {
  const { t } = useTranslation();
  const match = useRouteMatch<IMatch>();
  const bannerCode = Number(match.params.bannerCode);
  const history = useHistory();
  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetBanner>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios();

  useEffect(() => {
    execute(getBanner(bannerCode));
  }, []);

  useEffect(() => {
    if (res2 && !isLoading2) {
      successNotification(t('common.message.edit1'));
      history.push('/homepage/main-banner');
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (res3 && !isLoading3) {
      successNotification(t('common.message.delete'));
      history.push('/homepage/main-banner');
    }
  }, [res3, isLoading3]);

  const submit = (data: FormData) => {
    execute2(updateBanner(bannerCode, data));
  };

  const remove = () => {
    execute3(deleteBanner(bannerCode));
  };

  return (
    <div className="content scrollbar">
      {isLoading || isLoading2 || isLoading3 ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('common.menu.homepage')}
        currentMenu={t('homepage.mainBanner.title6')}
      />

      <Editor data={res?.data} submit={submit} remove={remove} />
    </div>
  );
};

export default MainBannerEdit;
